export const IconCustom = ({ iconUrl }) => {
  return (
    <div className="hotspot_icon_custom">
      <img alt="video-icon" src={iconUrl} style={{ width: '100%' }}></img>
    </div>
  );
};
